import React from 'react';
import { ChevronDown16Regular } from '@fluentui/react-icons';
import { Button, Dropdown, message, Space } from 'antd';
import IRepertoireComponentDataItem from '../../../../redux/types/IRepertoireComponentDataItem';
import { USAGERESULTTABLE_VIEW } from '../../../Consts';
import { IComponentView } from '../../../../redux/types/ComponentView';
import { IComponentViewsPreference } from '../../../../redux/types/IComponentViewsPreference';

export interface DropDownButtonDefaultView {
  showFieldsModal?: (componentFieldName: string) => void;
  settingsModalViewData?: IRepertoireComponentDataItem;
  componentViews?: IComponentView[];
  setActiveComponentView?: (activeComponentView: IComponentView) => void;
  activeComponentView?: IComponentView;
  componentViewPreference?: IComponentViewsPreference;
  isUserAdmin?: boolean;
  dropDownName?: string;
}

const CREATE_NEW_VIEW = "CreateNewView";
const DEFAULT_VIEW = "DefaultView";
const DEFAULT_VIEW_NAME = "Default View";

const DropDownButtonDefaultView: React.FC<DropDownButtonDefaultView> = ({
  setActiveComponentView,
  componentViewPreference,
  activeComponentView,
  componentViews,
  settingsModalViewData,
  showFieldsModal,
  isUserAdmin,
  dropDownName,
}) => {
  const [defaultViewName, setDefaultViewName] = React.useState(componentViewPreference?.[dropDownName] ? componentViewPreference[dropDownName] : DEFAULT_VIEW_NAME);
  const [viewOptions, setViewOptions] = React.useState<any[]>([]);

  React.useEffect(() => {
    const newItems: any[] = isUserAdmin ? [
      {
        type: 'divider',
      },
      {
        label: <span style={{ fontWeight: 'bold' }}>{settingsModalViewData?.fields?.find(f => f.name === CREATE_NEW_VIEW)?.data || 'Create new view'}</span>,
        key: CREATE_NEW_VIEW,
      },
    ] : [];

    if (componentViews?.length) {
      const sortedViews = componentViews
    .filter((view) => !view.isDeleted)
    .sort((a, b) => b.viewName.localeCompare(a.viewName))
      sortedViews.forEach((view) => {
        if (view.isDeleted) {
          return;
        }
        newItems.unshift({
          label: view.viewName,
          key: view.viewName,
        });
      });
    }

    setViewOptions(newItems);
  }, [componentViews, settingsModalViewData]);

  React.useEffect(() => {
    const defaultName = componentViewPreference?.[dropDownName] ? componentViewPreference[dropDownName] : settingsModalViewData?.fields?.find(f => f.name === DEFAULT_VIEW)?.data || 'Default view';
    setDefaultViewName(defaultName);
    handleSetInitialViewBasedOnComponentPreference();
  }, [settingsModalViewData, componentViewPreference]);

  const handleSetActiveView = (view: IComponentView | undefined) => {
    if (view && setActiveComponentView) {
      setActiveComponentView(view);
    }
  };

  const handleSetInitialViewBasedOnComponentPreference = () => {
    if (componentViews && componentViews.length > 0 && componentViewPreference && dropDownName && activeComponentView?.viewName !== componentViewPreference[dropDownName]) {
      const preferredView = componentViews.find(view => view.viewName === componentViewPreference[dropDownName]);
      setActiveComponentView && preferredView && setActiveComponentView(preferredView);
    }
  }

  const handleButtonClick = (e: any) => {};

  const handleMenuClick = (e: any) => {
    if (e.key === CREATE_NEW_VIEW) {
      if (showFieldsModal) {
        showFieldsModal(USAGERESULTTABLE_VIEW);
      }
    } else {
      const selectedView = componentViews?.find(view => view.viewName === e.key);
      if (selectedView) {
      handleSetActiveView(selectedView);
    }
    }
  };

  const menuProps = {
    items: viewOptions,
    onClick: handleMenuClick,
  };

  return (
    <Space wrap style={{ maxHeight: 200, overflowY: 'auto' }}>
      <Dropdown menu={menuProps}>
        <Button onClick={handleButtonClick} size="small">
          <Space>
            {defaultViewName || activeComponentView?.viewName}
            <ChevronDown16Regular className="icon" />
          </Space>
        </Button>
      </Dropdown>
    </Space>
  );
};

export default DropDownButtonDefaultView;